import React from "react";
import user1 from "../assets/user-1.jpg";
import user2 from "../assets/user-2.jpg";
import user3 from "../assets/user-3.jpg";
import user4 from "../assets/user-4.jpg";
import axis from "../assets/BankLogo/axis-finance.png";
import icici from "../assets/BankLogo/icici-finance.png";
import bandhan from "../assets/BankLogo/bandhan-finance.png";
import hdfc from "../assets/BankLogo/hdfc-finance.png";
import kotak from "../assets/BankLogo/kotak-finance.png";
import bob from "../assets/BankLogo/bob-finance.png";
import induslnd from "../assets/BankLogo/induslnd-finance.png";

const TestiMonials = () => {
  
  return (
    <div id="testimonials" className="testimonials-comp">
      <div className="testimonials-container">
        <div className="testimonials-content">
          <div className="testimonials-header">
            <p className="testimonials-subtitle">Testimonials</p>
          </div>
          <div className="testimonials-description-content">
            <p className="testimonials-text">
              <span className="faq-questions-icon">●</span>
              Right Lender helps you achieve your financial goals with ease. We
              take pride in guiding customers through every step of the loan
              process,{" "}
              <span className="highlight-color">
                ensuring smooth and hassle-free approvals
              </span>
              . So far, we have successfully supported a wide range of
              individuals, including doctors, Category A and Super Category A
              employees, professionals, business owners, and NRIs. Our services
              have enabled many to start or expand businesses, purchase or build
              their dream homes, and even establish hospitals. For NRIs, our
              offerings are especially valuable — allowing them to secure loans
              in India while living abroad, with all formalities handled by our
              team before their visit.
            </p>
            <p className="testimonials-text">
              <span className="faq-questions-icon">●</span>
              To date,{" "}
              <span className="highlight-color">
                we have disbursed over ₹1186+ crores{" "}
              </span>
              across{" "}
              <span className="highlight-color">
                Home Loans, Business Loans, Mortgage Loans, NRI Loans, and
                Personal Loans{" "}
              </span>
              , empowering 2,356+ customers and backed by a growing base of more
              than 6,000+ users. With strong partnerships across 65+ Banks &
              NBFCs, and with trust, technology, and dedicated service at our
              core, Right Lender continues to grow rapidly — making borrowing
              smarter, faster, and easier for everyone.
            </p>
            <div className="testimonials-total-counts">
              <div className="testimonials-project-counts">
                <h1>15+</h1>
                <p>Years of Service</p>
              </div>
              <div className="testimonials-customer-counts">
                <h1>65+</h1>
                <p>Bank & NBFC and Growing</p>
              </div>
              <div className="testimonials-project-counts">
                <h1> ₹1186+</h1>
                <p>Crores Disbursed</p>
              </div>
            </div>
            <div className="testimonials-bottom-header">
              <p className="testimonials-bottom-title">
                “Right Lender is currently serving Tamil Nadu and Bangalore, and
                will soon be expanding across India.”
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="testimonials-company">
        <p className="testimonials-company-title">
          Trusted by Leading Financial Institutions
        </p>
        <div className="testimonials-wrapper">
          <div className="testimonials-company-logos">
            <img src={axis} alt="axis" className="company-logo" />
            <img src={icici} alt="icici" className="company-logo" />
            <img src={bandhan} alt="bandhan" className="company-logo" />
            <img src={hdfc} alt="hdfc" className="company-logo" />
            <img src={kotak} alt="kotak" className="company-logo" />
            <img src={bob} alt="bob" className="company-logo" />
            <img src={induslnd} alt="induslnd" className="company-logo" />

            <img src={axis} alt="axis" className="company-logo" />
            <img src={icici} alt="icici" className="company-logo" />
            <img src={bandhan} alt="bandhan" className="company-logo" />
            <img src={hdfc} alt="hdfc" className="company-logo" />
            <img src={kotak} alt="kotak" className="company-logo" />
            <img src={bob} alt="bob" className="company-logo" />
            <img src={induslnd} alt="induslnd" className="company-logo" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TestiMonials;
